import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store'
import AdminUserList from '@/views/admin/user/list'
import HttpTraceLog from '@/views/admin/log/httptrace'
import UserRegionalList from '@/views/admin/analysis/user/list'
import DeviceRegionalList from '@/views/admin/analysis/device/list'

Vue.use(Router)

let router = new Router({
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home,
        redirect: '/adminUser',
        children:[
          {
            path: 'adminUser',
            name: 'adminUser',
            component: AdminUserList
          },
          {
            path: 'user/regional',
            name: 'userRegional',
            component: UserRegionalList
          },
          {
            path: 'device/regional',
            name: 'deviceRegional',
            component: DeviceRegionalList
          },
          {
            path: 'httptrace',
            name: 'httptrace',
            component: HttpTraceLog
          }
        ],
        meta: {
            requiresAuth: true
        }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }//把要跳转的地址作为参数传到下一步
      })
      return
    }
    next()
  } else {
    next()
  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js